{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Šablony WhatsApp",
      "SUBTITLE": "Vyberte šablonu WhatsApp, kterou chcete odeslat",
      "TEMPLATE_SELECTED_SUBTITLE": "Zpracování {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Hledat šablony",
      "NO_TEMPLATES_FOUND": "Žádné šablony nenalezeny pro",
      "LABELS": {
        "LANGUAGE": "Jazyk",
        "TEMPLATE_BODY": "Obsah šablony",
        "CATEGORY": "Kategorie"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Proměnné",
      "VARIABLE_PLACEHOLDER": "Zadejte hodnotu pro {variable}",
      "GO_BACK_LABEL": "Zpět",
      "SEND_MESSAGE_LABEL": "Odeslat zprávu",
      "FORM_ERROR_MESSAGE": "Před odesláním prosím vyplňte všechny proměnné"
    }
  }
}